import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Cta from "../components/Cta";
import InnerHead from "../components/InnerHead";
import Details from "../components/Details";
import Speakers from "../components/Speakers";
import Tracks from "../components/Tracks";
import AboutUs from "../components/AboutUs";
import Countdown from "../components/Countdown";
import Footer from "../components/Footer";
import { client } from "../config/prismic";

const Home = () => {
  const [home, setHome] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("home");
      setHome(response.results[0]?.data); // Accessing the first result's data directly
    };
    fetchData();
  }, []);

  if (!home) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <Hero home={home} />
      <AboutUs />
      {/* <Countdown /> */}
      <Details />
      <Tracks />
      <Cta />
      {/* <InnerHead /> */}
      {/* <Speakers /> */}
      <Footer />
    </div>
  );
};

export default Home;
